export default {
      id: "graph-house-usage",
      viewBox: "0 0 48 65",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-house",
      toString: function () {
        return this.url;
      }
    }